import { Helmet } from "react-helmet-async";

import HomeSlider from "./Homeslider";
import CategorySection from "../Category/category";
import Contact from "../Contact/Contact";
import IngredientSearch from "../SearchByIngrediants/IngredientSearch";

function Home() {
  return (
    <>
      <Helmet>
        <title>Flavours Nest - Easy & Delicious Recipes</title>

        <meta
          name="description"
          content="Discover easy and delicious recipes on Flavours Nest. Browse categories, search by ingredients, and cook amazing meals at home."
        />

        {/* Open Graph (WhatsApp, Facebook) */}
        <meta property="og:title" content="Flavours Nest - Easy Recipes" />
        <meta
          property="og:description"
          content="Find tasty recipes with step-by-step instructions."
        />
        <meta
          property="og:image"
          content="https://flavoursnest.com/misalpav.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://flavoursnest.com/" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Flavours Nest - Recipes" />
        <meta
          name="twitter:description"
          content="Cook delicious meals with easy recipes."
        />
        <meta
          name="twitter:image"
          content="https://flavoursnest.com/misalpav.png"
        />
      </Helmet>

      <HomeSlider />
      <CategorySection />
      <IngredientSearch />
      <Contact isHome={true}/>
    </>
  );
}

export default Home;